import { VehicleForm, VehicleFuelEntryForm, VehicleMeterReadingEntryForm } from '@/models'
import type { TVehiclesState } from '@/types/state-types'

export default <TVehiclesState>{
  vehicleForm: new VehicleForm(),
  isVehicleLoading: false,
  vehicleFuelEntryForm: new VehicleFuelEntryForm(),
  vehicleMeterEntryForm: new VehicleMeterReadingEntryForm()
}
